var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8387 19.4078C12.3656 20.341 14.3167 20.1713 15.5892 18.8988L16.0981 18.3899C16.6071 17.8809 16.6071 17.1174 16.0981 16.6084L13.8925 14.318C13.3836 13.809 12.6201 13.809 12.1111 14.318C11.6021 14.827 10.8387 14.827 10.3297 14.318L6.76682 10.7552C6.25784 10.2462 6.25784 9.4827 6.76682 8.97372C7.2758 8.46474 7.2758 7.70127 6.76682 7.19229L4.39157 4.90188C3.88259 4.3929 3.11912 4.3929 2.61014 4.90188L2.10116 5.41086C0.828708 6.68331 0.659048 8.6344 1.59218 10.1613C4.05225 13.809 7.19097 16.9478 10.8387 19.4078Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90479 7.3623C12.0255 7.3623 13.7221 9.05891 13.7221 11.1797",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90479 4.13882C13.807 4.13882 16.9457 7.27754 16.9457 11.1797",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90479 1C15.5036 1 20.0844 5.58083 20.0844 11.1796",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.84349ecddc9d27c7051b850bd8fe28e8.svg";
export { ForwardRef as ReactComponent };